// extracted by mini-css-extract-plugin
module.exports = {"scylndx":"scylndx"};